import { createContext } from 'react';
import { useChartsData } from '../../hooks/useChartsData';
import { useFiltersContext } from '../../Filters/hooks/useFiltersContext';
import { useGeneratedColorArray, coresMescladasArray } from '../../styles/colors';

export const ServicesChartsDataContext = createContext();

// Usa let para permitir reatribuição
export let defaultColors = coresMescladasArray

const ServicesChartsDataProvider = ({
    module,
    queryConfig,
    children,
    subtitlesMap,
    filterParams,
    chartDataMapper
}) => {
    const { filters } = useFiltersContext();

    const resolvedFilterParams =
        typeof filterParams === 'function'
            ? filterParams(filters)
            : filterParams ?? {
                  location: filters.unidade?.value,
                  year: filters.ano?.value,
                  month: filters.competencia?.value
              };

    const { data, isLoading, isError } = useChartsData(
        queryConfig,
        resolvedFilterParams
    );
    
    // Usa o hook para gerar cores dinamicamente do Redux
    const dynamicColors = useGeneratedColorArray();
    
    // Atualiza defaultColors para que outros arquivos que importam também usem as cores dinâmicas
    defaultColors = dynamicColors;

    const chartData = chartDataMapper
        ? chartDataMapper(data)
        : data
        ? {
              counterYear: data.counterYear || [],
              selectedYear: data.selectedYear || []
          }
        : {
              counterYear: [],
              selectedYear: []
          };

    const subtitles = subtitlesMap?.[queryConfig.key]
        ? subtitlesMap[queryConfig.key].map((item) => item.description)
        : Array.from(
              new Set(data?.counterYear?.map((item) => item.description ?? '-'))
          );

    const colors = dynamicColors;

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitles,
                colors,
                isLoading,
                isError,
                filters,
                module,
                queryConfig,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
